import { EstimatedPayForPensionClient } from "../../../../../../Wrap/Api/Tax/EstimatedPayForPension";
import { EstimatedPaysForPensionClient } from "../../../../../../Wrap/Api/Tax/EstimatedPaysForPension";
import { PensionEstimatedPayQuery } from "../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPayQuery";

export class EstimatedPayeAction {
  
    public static calculateEstimatedPaye(query: PensionEstimatedPayQuery, callback){
        const client = new EstimatedPayForPensionClient();

        const promise = client.post(query);
        promise.onSuccess((data) => {
            callback({
                success: true, 
                data: data
            });
        });

        promise.onError((err) => {
            callback({success: false });
        });
    }

    public static calculateEstimatedPayes(query: Array<PensionEstimatedPayQuery>, callback){
        const client = new EstimatedPaysForPensionClient();

        const promise = client.post(query);
        promise.onSuccess((data) => {
            callback({
                success: true, 
                data: data
            });
        });

        promise.onError((err) => {
            callback({success: false });
        });
    }
}
